import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../Header/Navbar';
import Footer from '../Footer/Footer';
import BackToTop from '../BackToTop/BackToTop';
import Topbar from '../Header/Topbar';
import ProductGrid from './ProductGrid';
import Pagination from './Pagination';
import SEO from '../SEO/SEO';
import './Products.css';

const LuminousProducts = () => {
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  const luminousCategories = [
    { id: 'inverlast', name: 'INVERLAST - Luminous Batteries', brand: 'luminous' },
    { id: 'extra-charge', name: 'EXTRA CHARGE', brand: 'luminous' },
    { id: 'red-charge', name: 'RED CHARGE', brand: 'luminous' },
    { id: 'power-charge', name: 'POWER CHARGE', brand: 'luminous' },
    { id: 'shakti-charge', name: 'SHAKTI CHARGE', brand: 'luminous' },
    { id: 'invergel', name: 'INVERGEL', brand: 'luminous' },
    { id: 'life-max', name: 'LIFE MAX', brand: 'luminous' },
    { id: 'solar-battery', name: 'Luminous Solar Battery', brand: 'luminous' }
  ];

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const clearSearch = () => {
    setSearchQuery('');
    setCurrentPage(1);
  };

  const getTotalProducts = () => {
    const productCounts = {
      'inverlast': 16,
      'extra-charge': 1,
      'red-charge': 4,
      'power-charge': 2,
      'shakti-charge': 2,
      'invergel': 1,
      'life-max': 1,
      'solar-battery': 12
    };
    
    return Object.values(productCounts).reduce((sum, count) => sum + count, 0);
  };

  return (
    <>
      <SEO 
        title="Luminous Batteries"
        description="Discover Luminous power solutions at Galaxy Power System, Chidambaram. Authorized dealer for Luminous inverters, solar batteries, and more."
        keywords="luminous battery dealer, luminous inverter chidambaram, luminous solar battery, power backup solutions"
        canonicalUrl="https://galaxypowersystems.com/luminous-products"
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Luminous Products', url: '/luminous-products' }
        ]}
      />
      <Topbar />
      <Navbar />
      <div className="container-fluid product py-5" id="products">
        <div className="container py-5">
          <div className="row mb-5">
            <div className="col-12 text-center">
              <h1 className="display-5 mb-3" style={{ color: '#2E8B57' }}>
                <i className="fas fa-sun me-2"></i> Luminous Batteries
              </h1>
              <p className="lead text-muted mb-4">
                Luminous Power Technologies is one of India's leading power backup solutions providers. 
                They offer innovative inverter and battery solutions for homes and businesses.
              </p>
            </div>
          </div>

          <div className="row g-4 align-items-center mb-5">
            <div className="col-lg-4 col-md-12">
              <h3 className="mb-0">All Luminous Products</h3>
            </div>
            
            <div className="col-lg-5 col-md-8">
              <div className="position-relative">
                <div className="d-flex border rounded-pill" style={{ backgroundColor: '#fff', borderColor: '#ddd' }}>
                  <input 
                    className="form-control border-0 rounded-pill w-100 py-2" 
                    type="text"
                    placeholder="Search Luminous products..."
                    value={searchQuery}
                    onChange={handleSearch}
                    style={{ fontSize: '14px' }}
                  />
                  {searchQuery && (
                    <button 
                      type="button" 
                      className="btn btn-link text-success"
                      onClick={clearSearch}
                      style={{ border: '0', fontSize: '14px' }}
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  )}
                </div>
              </div>
            </div>
            
            <div className="col-lg-3 col-md-4 text-end">
              <div className="badge bg-success rounded-pill py-2 px-4">
                Total Products: {getTotalProducts()}
              </div>
            </div>
          </div>
          
          <div className="tab-content">
            <ProductGrid 
              categories={luminousCategories} 
              currentPage={currentPage} 
              brand="luminous"
              searchQuery={searchQuery}
            />
            
            {/* Pagination */}
            {!searchQuery && (
              <Pagination 
                totalPages={luminousCategories.length}
                currentPage={currentPage}
                onPageChange={setCurrentPage}
                paginationId="luminous-pagination"
              />
            )}
          </div>
        </div>
      </div>
      <BackToTop />
      <Footer />
    </>
  );
};

export default LuminousProducts;